<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row>
              <b-col>
                Gráfico
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID !== null && arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID !== 0"
                        @click="openResourceWithParam('charts', arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID)"/>
                    <input type="text" v-model="arrayEleOperation[index].TRATAMIENTOINF_GRAF_NOMBRE"
                      disabled class="form-control" />
                    <searchcharts class="pl-2"
                      v-bind:idModal="'mdlSearchCharts_'+index"
                      v-on:selected="onSelectedChart($event, index)">
                    </searchcharts>
                  </div>
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col v-if="arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID !== null && arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID !== 0">
                <div>
                  Tipo Actividad<select class="form-control" v-model="arrayEleOperation[index].TIPO_ACTIVIDAD">
                    <!-- MOTOR 0 Tablas de doble entrada-->
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='0' || arrayEleOperation[index].TIPO_GRAFICO===0" value="0">Interpretar una tabla de doble entrada  (identificando el contenido de las celdas)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='0' || arrayEleOperation[index].TIPO_GRAFICO===0" value="1">Interpretar una tabla de doble entrada (preguntando por la totalidad de datos indicados por una fila o por una columna)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='0' || arrayEleOperation[index].TIPO_GRAFICO===0" value="2">Elaborar una tabla de doble entrada (Escribe la cantidad a partir de los datos suministrados)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='0' || arrayEleOperation[index].TIPO_GRAFICO===0" value="3">Elaborar una tabla de doble entrada (Señala el elemento correcto a partir de los elementos suministrados)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='0' || arrayEleOperation[index].TIPO_GRAFICO===0" value="4">Completar una tabla (Escribe la cantidad a partir de los datos suministrados)</option>
                    <!-- MOTOR 1 Coordenadas en cuadrícula-->
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='1' || arrayEleOperation[index].TIPO_GRAFICO===1" value="0">Interpretar coordenadas en la cuadrícula (identificando un elemento dadas sus coordenadas)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='1' || arrayEleOperation[index].TIPO_GRAFICO===1" value="1">Interpretar coordenadas en la cuadrícula (definiendo la posición de un elemento)</option>
                    <!-- MOTOR 2 Gráfico de barras-->
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='2' || arrayEleOperation[index].TIPO_GRAFICO===2" value="0">Interpretar un gráfico de barras (completando celdas a partir de los datos suministrados)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='2' || arrayEleOperation[index].TIPO_GRAFICO===2" value="1">Interpretar un  gráfico de barras (identificando el valor de una barra en una de sus características)</option>
                    <!-- MOTOR 3 Gráfico lineal-->
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='3' || arrayEleOperation[index].TIPO_GRAFICO===3" value="0">Interpretar un gráfico lineal (completando celdas a partir de los datos suministrados)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='3' || arrayEleOperation[index].TIPO_GRAFICO===3" value="1">Interpretar un gráfico lineal (identificando el valor de un punto en una de sus características)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='3' || arrayEleOperation[index].TIPO_GRAFICO===3" value="2">Interpretar un  gráfico lineal (preguntar por la suma del valor de dos puntos en una de sus características)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='3' || arrayEleOperation[index].TIPO_GRAFICO===3" value="3">Interpretar un gráfico lineal (preguntar que fila es mayor o menor en una de sus características)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='3' || arrayEleOperation[index].TIPO_GRAFICO===3" value="4">Interpretar un gráfico lineal (preguntar que característica es mayor o menor en una de sus filas)</option>
                    <!-- MOTOR 4 Pictograma-->
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='4' || arrayEleOperation[index].TIPO_GRAFICO===4" value="0">Interpretar un pictograma (completando celdas a partir de los datos suministrados)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='4' || arrayEleOperation[index].TIPO_GRAFICO===4" value="1">Interpretar un pictograma (preguntando por la totalidad de datos)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='4' || arrayEleOperation[index].TIPO_GRAFICO===4" value="2">Interpretar un pictograma (completando el símbolo a partir de los datos suministrados)</option>
                    <!-- MOTOR 5 Gráfico circular-->
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='5' || arrayEleOperation[index].TIPO_GRAFICO===5" value="0">Interpretar un gráfico circular (completando celdas a partir de los datos suministrados)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='5' || arrayEleOperation[index].TIPO_GRAFICO===5" value="1">Interpretar un gráfico circular (preguntar por el dato que representa uno o varios de sus sectores)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='5' || arrayEleOperation[index].TIPO_GRAFICO===5" value="2">Interpretar un gráfico circular (preguntar que sección es mayor o menor)</option>
                    <!-- MOTOR 6 Eje cartesiano-->
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='6' || arrayEleOperation[index].TIPO_GRAFICO===6" value="0">Interpretar un eje cartesiano (completando celdas a partir de los datos suministrados)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='6' || arrayEleOperation[index].TIPO_GRAFICO===6" value="1">Interpretar coordenadas en un eje cartesiano (definiendo la posición de un elemento)</option>
                    <option v-if="arrayEleOperation[index].TIPO_GRAFICO==='6' || arrayEleOperation[index].TIPO_GRAFICO===6" value="2">Interpretar coordenadas en un eje cartesiano (identificando un elemento dadas sus coordenadas)</option>
                  </select>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID !== null && arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID !== 0">
              <b-col>
                Tipo preguntas<select class="form-control" v-model="arrayEleOperation[index].TIPO_PREGUNTAS">
                  <option value="0">Señalar celda</option>
                  <option value="1">Escribir cantidad</option>
                </select>
              </b-col>
              <b-col v-if="parseInt(arrayEleOperation[index].TIPO_GRAFICO)!==0
              || (parseInt(arrayEleOperation[index].TIPO_GRAFICO)===0 && parseInt(arrayEleOperation[index].TIPO_ACTIVIDAD)!==4)">
                Numero de preguntas
                <b-form-input v-model="arrayEleOperation[index].NUM_PREGUNTAS" type="number"></b-form-input>
              </b-col>
              <b-col v-if="parseInt(arrayEleOperation[index].TIPO_GRAFICO)===0 && parseInt(arrayEleOperation[index].TIPO_ACTIVIDAD)===4">
                Imagen
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].IMAGENES_ID !== null && arrayEleOperation[index].IMAGENES_ID !== 0"
                      @click="cleanImageDesc(index)"/>
                  <div class="image">
                      <img :src="getTranslation(arrayEleOperation[index].IMAGENES_DESC)" alt="img"
                      style="width:110px;height:110px" class="img-fluid" v-if="arrayEleOperation[index].IMAGENES_ID !== null">
                      <span v-if="arrayEleOperation[index].IMAGENES_ID === null">Sin imagen</span>
                  </div>
                  <searchimages class="pl-2" :idModal="'mdlSearchImageDesc_'+index"
                    v-on:selected="onSelectedImageDesc($event, index)">
                  </searchimages>
                </div>
              </b-col>
              <b-col v-if="parseInt(arrayEleOperation[index].TIPO_GRAFICO)===0 && parseInt(arrayEleOperation[index].TIPO_ACTIVIDAD)===4">
                Descripción
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].TEXTOS_ID_DESCRIPCION !== null && arrayEleOperation[index].TEXTOS_ID_DESCRIPCION !== 0"
                      @click="cleanTextDesc(index)"/>
                  <input type="text" v-bind:value="getTranslation(arrayEleOperation[index].TEXTOS_DESCRIPCION)"
                  disabled class="form-control" />
                  <searchtexts class="pl-2" :idModal="'mdlSearchTextDesc_'+index"
                    v-on:selected="onSelectedTextDesc($event, index)">
                  </searchtexts>
                </div>
              </b-col>
            </b-row>
            <br />
            <b-row v-if="arrayEleOperation[index].FILAS > 0 && arrayEleOperation[index].COLUMNAS > 0">
              <b-col md="4">
                Tipo de gráfico
                <select class="form-control" v-model="arrayEleOperation[index].TIPO_GRAFICO" disabled="disabled">
                  <option value="0">Tablas de doble entrada</option>
                  <option value="1">Coordenadas en cuadrícula</option>
                  <option value="2">Gráfico de barras</option>
                  <option value="3">Gráfico lineal</option>
                  <option value="4">Pictograma</option>
                  <option value="5">Gráfico circular</option>
                  <option value="6">Eje cartesiano</option>
                </select>
              </b-col>
              <b-col md="4">
                Filas
                <b-form-input v-model="arrayEleOperation[index].FILAS" type="number"></b-form-input>
              </b-col>
              <b-col md="4">
                Columnas
                <b-form-input v-model="arrayEleOperation[index].COLUMNAS" type="number"></b-form-input>
              </b-col>
            </b-row>
            <br>
            <div class="text-center" v-if="arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID !== null">
              <button class="btn btn-secondary btn-sm" v-on:click="onViewCells(index)">Ver celdas</button>
            </div>
            <b-row v-if="arrayEleOperation[index].bVisible">
              <div v-for="ELEMENTO in arrayEleOperation[index].TRATAMIENTOINF_GRAF_ELEMENTS" v-bind:key="ELEMENTO.ID">
                <b-row class="justify-content-md-center">
                  <b-col sm="3">
                    Tipo de elemento <select class="form-control" v-model="ELEMENTO.TIPO_ELEMENTO" disabled>
                      <option value="0">Cabecera de fila</option>
                      <option value="1">Cabecera de columna</option>
                      <option value="2">Celda</option>
                      <option value="3">Pictograma</option>
                    </select>
                  </b-col>
                  <b-col>
                     Pos. Filas
                    <b-form-input style="width:70%" v-model="ELEMENTO.POSICION_FILA" type="number" readonly="readonly"></b-form-input>
                  </b-col>
                  <b-col>
                     Pos. Columnas
                    <b-form-input style="width:70%" v-model="ELEMENTO.POSICION_COLUMNA" type="number" readonly="readonly"></b-form-input>
                  </b-col>
                  <b-col>
                     Valor
                     <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-input
                          type="text" style="width:70%"
                          v-bind:id="'VALOR' + index + ELEMENTO.ID"
                          v-model="ELEMENTO.VALOR"  />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col v-if="parseInt(arrayEleOperation[index].TIPO_GRAFICO)===0 && parseInt(arrayEleOperation[index].TIPO_ACTIVIDAD)===4">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input"
                        v-model="ELEMENTO.INCOGNITA"
                        v-bind:id="'INCOGNITA'+index + ELEMENTO.ID">
                      <label class="custom-control-label" v-bind:for="'INCOGNITA'+index + ELEMENTO.ID">Incognita</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input"
                        v-model="ELEMENTO.VISIBLE"
                        v-bind:id="'VISIBLE'+index + ELEMENTO.ID">
                      <label class="custom-control-label" v-bind:for="'VISIBLE'+index + ELEMENTO.ID">Visible</label>
                    </div>
                  </b-col>
                  <b-col v-if="parseInt(arrayEleOperation[index].TIPO_GRAFICO)===0 && parseInt(arrayEleOperation[index].TIPO_ACTIVIDAD)===4">
                    Orden Pregunta
                    <b-form-input style="width:70%"
                      v-bind:id="'ORDEN'+index + ELEMENTO.ID" type="number"
                      v-model="ELEMENTO.ORDEN" />
                  </b-col>
                </b-row>
              </div>
            </b-row>
          <hr/>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';
import translationMixin from '../../../../mixins/translation';
import searchcharts from '../../charts/SearchCharts.vue';
import searchimages from '../../images/SearchImages.vue';
import searchtexts from '../../texts/SearchTexts.vue';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin, translationMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
    searchcharts,
    searchimages,
    searchtexts,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla TRATAMIENTOINF_CONF
      configuration: {
        ID: -1,
        EJERCICIOS_ID: -1, //
      },
    };
  },
  validations: {
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        bVisible: true,
        POSICION: this.arrayEleOperation.length + 1,
        TIPO_GRAFICO: '0',
        TIPO_ACTIVIDAD: '0',
        FILAS: 0,
        COLUMNAS: 0,
        TIPO_PREGUNTAS: '0',
        NUM_PREGUNTAS: 1,
        TEXTOS_ID_DESCRIPCION: null,
        TEXTOS_DESCRIPCION: [],
        IMAGENES_ID: null,
        IMAGENES_DESC: [],
        TRATAMIENTOINF_GRAF_ID: null,
        TRATAMIENTOINF_GRAF_NOMBRE: null,
        TRATAMIENTOINF_GRAF_ELEMENTS: [],
        TRATAMIENTOINF_GRAF_NUMELEMENTS: null,
      });
    },
    /**
    * @method saveStorage
    * @description Guarda los datos del formulario
    */
    saveStorage() {
      this.$refs.exercise_child.$refs.formValidation.validate().then((exerciseOK) => {
        if (!exerciseOK) {
          return;
        }

        this.$refs.formValidation.validate().then((success) => {
          if (!success) {
            return;
          }

          this.$nextTick(() => {
            this.$refs.exercise_child.active();
          });

          const { objexercise } = this.$refs.exercise_child;
          const elemntsoperation = [];
          this.arrayEleOperation.forEach((element) => {
            const values = [];
            element.TRATAMIENTOINF_GRAF_ELEMENTS.forEach((value) => {
              values.push({
                VALOR: value.VALOR,
                INCOGNITA: value.INCOGNITA,
                VISIBLE: value.VISIBLE,
                ORDEN: value.ORDEN,
                TIPO_ELEMENTO: value.TIPO_ELEMENTO,
                POSICION_FILA: value.POSICION_FILA,
                POSICION_COLUMNA: value.POSICION_COLUMNA,
                TRATAMIENTOINF_GRAF_ELE_ID: value.ID,
              });
            });
            elemntsoperation.push({
              POSICION: element.POSICION,
              TIPO_GRAFICO: element.TIPO_GRAFICO,
              TIPO_ACTIVIDAD: element.TIPO_ACTIVIDAD,
              FILAS: element.FILAS,
              COLUMNAS: element.COLUMNAS,
              TIPO_PREGUNTAS: element.TIPO_PREGUNTAS,
              NUM_PREGUNTAS: element.NUM_PREGUNTAS,
              TEXTOS_ID_DESCRIPCION: element.TEXTOS_ID_DESCRIPCION,
              TEXTOS_DESCRIPCION: element.TEXTOS_DESCRIPCION,
              IMAGENES_ID: element.IMAGENES_ID,
              IMAGENES_DESC: element.IMAGENES_DESC,
              TRATAMIENTOINF_GRAF_ID: element.TRATAMIENTOINF_GRAF_ID,
              TRATAMIENTOINF_GRAF_NOMBRE: element.TRATAMIENTOINF_GRAF_NOMBRE,
              TRATAMIENTOINF_GRAF_ELEMENTS: values,
            });
          });
          const motorData = {
            exercise: objexercise,
            configuration: this.configuration,
            elements: elemntsoperation,
            totalElements: this.arrayEleOperation.length,
          };

          let exerciseID = null;
          if (this.$props.exercise) {
            exerciseID = this.$props.exercise.ID;
          }
          if (exerciseID === null) { // Means there is no exercise created here, get tempID from storage
            const tempID = window.sessionStorage.getItem('tempEngineID');
            exerciseID = `tempID_${this.type}_${tempID}`;
          }
          console.log(`saveStorage: ${exerciseID}`);

          // Grabo los datos del motor
          window.sessionStorage.setItem(`engine_${this.type}_${exerciseID}`, JSON.stringify(motorData));

          // Cierro el modal
          this.$root.$emit('bv::hide::modal', `baseEngineModal_${this.type}`);
        });
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('informationcharts/getinformationcharts', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            bVisible: false,
            POSICION: element.POSICION,
            TIPO_GRAFICO: element.TIPO_GRAFICO,
            TIPO_ACTIVIDAD: element.TIPO_ACTIVIDAD,
            FILAS: element.FILAS,
            COLUMNAS: element.COLUMNAS,
            TIPO_PREGUNTAS: element.TIPO_PREGUNTAS,
            NUM_PREGUNTAS: element.NUM_PREGUNTAS,
            TEXTOS_ID_DESCRIPCION: element.TEXTOS_ID_DESCRIPCION,
            TEXTOS_DESCRIPCION: element.TEXTOS_DESCRIPCION,
            IMAGENES_ID: element.IMAGENES_ID,
            IMAGENES_DESC: element.IMAGENES_DESC,
            TRATAMIENTOINF_GRAF_ID: element.TRATAMIENTOINF_GRAF_ID,
            TRATAMIENTOINF_GRAF_NOMBRE: element.TRATAMIENTOINF_GRAF_NOMBRE,
            TRATAMIENTOINF_GRAF_ELEMENTS: element.CHARTSVALUES,
            TRATAMIENTOINF_GRAF_NUMELEMENTS: element.CHARTSVALUES.length,
          });

          // this.loadEleItems(element.TRATAMIENTOINF_GRAF_ID, index);
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
    cleanTextDesc(pos) {
      this.arrayEleOperation[pos].TEXTOS_ID_DESCRIPCION = null;
      this.arrayEleOperation[pos].TEXTOS_DESCRIPCION = [];
    },
    onSelectedTextDesc(itemSelected, pos) {
      this.arrayEleOperation[pos].TEXTOS_ID_DESCRIPCION = itemSelected.ID;
      this.arrayEleOperation[pos].TEXTOS_DESCRIPCION = [];
      this.setTranslation('TEXTO_', itemSelected, this.arrayEleOperation[pos].TEXTOS_DESCRIPCION);
      this.$root.$emit('bv::hide::modal', `mdlSearchTextDesc_${pos}`);
    },
    cleanImageDesc(pos) {
      this.arrayEleOperation[pos].IMAGENES_ID = null;
      this.arrayEleOperation[pos].IMAGENES_DESC = [];
    },
    onSelectedImageDesc(itemSelected, pos) {
      this.arrayEleOperation[pos].IMAGENES_ID = itemSelected.ID;
      this.arrayEleOperation[pos].IMAGENES_DESC = [];
      this.setTranslation('FICHERO_', itemSelected, this.arrayEleOperation[pos].IMAGENES_DESC);
      this.$root.$emit('bv::hide::modal', `mdlSearchImageDesc_${pos}`);
    },
    /**
    * @method onSelectedChart
    * @description Al buscar un grafico
    */
    async onSelectedChart(itemSelected, index) {
      this.arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID = itemSelected.ID;
      this.arrayEleOperation[index].TIPO_GRAFICO = itemSelected.TIPO_GRAFICO;
      this.arrayEleOperation[index].FILAS = itemSelected.FILAS;
      this.arrayEleOperation[index].COLUMNAS = itemSelected.COLUMNAS;
      this.arrayEleOperation[index].TRATAMIENTOINF_GRAF_NOMBRE = itemSelected.NOMBRE;
      this.arrayEleOperation[index].TEXTOS_ID_DESCRIPCION = itemSelected.TEXTOS_ID_DESCRIPCION;
      this.arrayEleOperation[index].TEXTOS_DESCRIPCION = itemSelected.TEXTOS_DESCRIPCION;
      this.arrayEleOperation[index].IMAGENES_ID = itemSelected.IMAGENES_ID;
      this.arrayEleOperation[index].IMAGENES_DESC = itemSelected.IMAGENES_DESC;
      this.arrayEleOperation[index].bVisible = true;
      this.loadEleItems(itemSelected.ID, index);

      this.$root.$emit('bv::hide::modal', `mdlSearchCharts_${index}`);
    },
    /**
    * @method onViewCells
    * @description Toggle view cells data. Loads TRATAMIENTOINF_GRAF_ELEMENTS if not loaded before
    */
    async onViewCells(index) {
      if (this.arrayEleOperation[index].TRATAMIENTOINF_GRAF_ELEMENTS.length <= 0) {
        await this.loadEleItems(this.arrayEleOperation[index].TRATAMIENTOINF_GRAF_ID, index);
      }
      this.arrayEleOperation[index].bVisible = !this.arrayEleOperation[index].bVisible;
    },
    async loadEleItems(ID, index) {
      // Obtener Elementos de un Grafico
      this.loading = true;
      try {
        const response = await this.axios.get('charts/getcharteles', {
          params: {
            id: ID,
          },
        });
        this.arrayEleOperation[index].TRATAMIENTOINF_GRAF_ELEMENTS = response.data.elements;
        this.arrayEleOperation[index].TRATAMIENTOINF_GRAF_NUMELEMENTS = response.data.elements.length;
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer elementos de un gráfico', { type: 'warning' });
      }
      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
